import { render, staticRenderFns } from "./ShareTwo.vue?vue&type=template&id=623d9398&scoped=true"
import script from "./ShareTwo.vue?vue&type=script&lang=js"
export * from "./ShareTwo.vue?vue&type=script&lang=js"
import style0 from "./ShareTwo.vue?vue&type=style&index=0&id=623d9398&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d9398",
  null
  
)

export default component.exports